import { styled } from '@mui/material'
import { ActionButton } from 'components/Buttons/ActionButton'

export const OrderButton = styled(ActionButton)`
  height: 48px;
  color: #fff;
  font-size: 16px;
  line-height: 16px;
  border-radius: 24px;
  &:disabled {
    cursor: not-allowed;
    color: #fff;
  }
`
OrderButton.defaultProps = {
  fullWidth: true,
}

export const LongOrderButton = styled(OrderButton)`
  height: 44px;
  background: ${({ theme }) => theme.color.buy50};
  &:disabled {
    background: rgba(72, 170, 131, 1);
    color: rgba(255, 255, 255, 0.5);
  }
  &:hover {
    &:not(:disabled) {
      background: ${({ theme }) => theme.color.buy60};
    }
  }
`

export const ShortOrderButton = styled(OrderButton)`
  height: 44px;
  background: ${({ theme }) => theme.color.sell50};
  &:disabled {
    background: rgba(206, 104, 118, 1);
    color: rgba(255, 255, 255, 0.5);
  }
  &:hover {
    &:not(:disabled) {
      background: ${({ theme }) => theme.color.sell60};
    }
  }
`
